import dayjs from 'dayjs';
import React from 'react';
import { DictType } from 'core-lib/types/Helper';
import s from './FuelTable.module.scss';

function FuelTable({ data }: DictType) {
  const today = dayjs(new Date()).format('DD MMM');

  return (
    <>
      <section className={s.root}>
        <table
          className={s.table}
          data-name={`Petrol, Diesel, and CNG Price in ${data?.city_name}`}
          itemScope
          itemType="http://schema.org/Table"
        >
          <thead>
            <tr>
              <th>
                <p>
                  <span itemProp="name">Day</span>
                  <span className={s.neutral}>Change</span>
                </p>
              </th>
              <th>
                <p>
                  <span itemProp="name">Petrol</span>
                  <span
                    className={
                      data?.petrol[0]?.change > 0
                        ? s.negative_change
                        : s.positive_change
                    }
                  >
                    {data?.petrol[0]?.change}
                  </span>
                </p>
              </th>
              <th>
                <p>
                  <span itemProp="name">Diesel</span>
                  <span
                    className={
                      data?.diesel[0]?.change > 0
                        ? s.negative_change
                        : s.positive_change
                    }
                  >
                    {data?.diesel[0]?.change}
                  </span>
                </p>
              </th>
              <th>
                <p>
                  <span itemProp="name">CNG</span>
                  <span
                    className={
                      data?.cng[0]?.change > 0
                        ? s.negative_change
                        : s.positive_change
                    }
                  >
                    {data?.cng[0]?.change}
                  </span>
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.petrol.map((item, idx) => {
              const day = dayjs(item?.date).format('DD MMM');
              return (
                <tr key={day}>
                  <td itemProp="description">
                    {day === today ? 'Today' : day}
                  </td>
                  <td itemProp="description">{item?.price}</td>
                  <td itemProp="description">
                    {data?.diesel[idx] ? data?.diesel[idx]?.price : 'NA'}
                  </td>
                  <td itemProp="description">
                    {data?.cng[idx] ? data?.cng[idx]?.price : 'NA'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <p className={s.warning}>
          Note : there may be slight variations in prices across outlets within
          a city
        </p>
      </section>
    </>
  );
}

export default FuelTable;
